import React, { Component } from 'react'
import {
  Line,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Label,
  ComposedChart,
  CartesianGrid,
  ResponsiveContainer
} from 'recharts'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

class Chart extends Component {
  render() {
    let halfyear = ['1st Half', '2nd Half']
    let quarter = ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4']
    let month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    let data = []
    let is_show_variance = this.props.chartData.is_show_variance

    let frequencyName = ''
    this.props.chartData.graph_data.map(graph => {
      var labels = []
      frequencyName = graph.frequency_type_name
      // graph.frequency_type_code = "FQT01"; //Unit Test Yearly
      if (graph.frequency_type_code === 'FQT02') labels = halfyear
      else if (graph.frequency_type_code === 'FQT03') labels = quarter
      else if (['FQT04', 'FQT06'].indexOf(graph.frequency_type_code)) labels = month

      graph.result_kpi.map((frequency, index) => {
        data.push({
          frequency_type_code: graph.frequency_type_code,
          frequency_no: +frequency.frequency_no,
          date: this.props.chartData.date,
          labels:
            graph.frequency_type_code === 'FQT01'
              ? new Date(this.props.chartData.date).getFullYear()
              : labels.find((label, idx) => idx === index),
          Target: +frequency.target_value,
          Actual: +frequency.actual_value,
          Diff: +graph.plot_data[index],
          Growth: +graph.plot_data[index]
        })

        return frequency
      })

      return graph
    })

    return (
      <ResponsiveContainer>
        <ComposedChart
          width={400}
          height={200}
          data={data}
          margin={{ top: 20, right: 25, bottom: 20, left: 25 }}>
          <Legend />
          <CartesianGrid stroke='#ccc' strokeDasharray='3 3' />
          <XAxis dataKey='labels'>
            {/* <Label value={this.props.translate('')} offset={0} position='insideBottom' /> */}
          </XAxis>
          <YAxis
            dataKey='Actual'
            orientation='left'
            yAxisId={0}
            type='number'
            domain={[0, 'dataMax + 20']}>
            {/* <Label value={this.props.translate('')} angle={90} position='insideLeft' /> */}
            <Label
              value={frequencyName + ' Actual'}
              angle={-90}
              offset={0}
              position='outsideLeft'
            />
          </YAxis>
          <YAxis dataKey={is_show_variance ? 'Diff' : 'Growth'} orientation='right' yAxisId={1}>
            {/* <Label value={this.props.translate('')} angle={-90} position='insideLeft' /> */}
            <Label
              value={is_show_variance ? 'Diff' : 'Growth'}
              angle={90}
              offset={0}
              position='outsideRight'
            />
          </YAxis>
          <Tooltip />
          <Bar dataKey='Actual' barSize={40} fill='#47899E' />
          <Line
            type='monotone'
            strokeWidth={2}
            dataKey={is_show_variance ? 'Diff' : 'Growth'}
            stroke='#F6B213'
            activeDot={{ r: 5 }}
            formatter={data => new Intl.NumberFormat('en').format(data)}
            yAxisId={1}
            // dot={<CustomizedDot />}
            // dot={{ stroke: 'red', strokeWidth: 2 }}
            // animationDuration={3500}
          />
          <Line
            type='monotone'
            strokeWidth={2}
            dataKey='Target'
            stroke='#EF7A1A'
            // EF7A1A
            activeDot={{ r: 5 }}
            formatter={data => new Intl.NumberFormat('en').format(data)}
            // dot={<CustomizedDot />}
            // dot={{ stroke: 'red', strokeWidth: 2 }}
            // animationDuration={3500}
          />
          {/* <Line type='monotone' dataKey='uv' stroke='#ff7300' /> */}
        </ComposedChart>
      </ResponsiveContainer>
    )
  }
}

export default withTranslate(Chart)
